<template>
    <div>

        <CardShell>

            <NoResults v-if="resultCount === 0" />

            <div v-if="resultCount > 0">
                <div class="pv3 bg-near-white">
                    <h5 class="ph3">{{resultCount}} Result<span v-if="resultCount > 1">s</span></h5>
                </div>
                <ToolList :tools="searchResults" />
                <StickyFooter class="dn-ns">
                    <TooliabaButton @click="filterResultsClick">Filter {{resultCount}} Results</TooliabaButton>
                </StickyFooter>                
            </div>
            
            <HugeSpinner v-if="searching"/>

        </CardShell>

        <div class="tc pt3 pt4-ns ph3" v-if="showMoreUrl" >
            <a class="flex items-center center th dib tc w-100 w5-ns bg-black white button link grow pointer" @click="getMoreResults">
                <div class="center">Show More</div>                
            </a>
        </div>

    </div>
</template>

<script>
import HugeSpinner from '@/components/controls/HugeSpinner.vue';
import CardShell from '@/components/global/CardShell.vue';
import ToolList from '@/components/global/ToolList.vue';
import NoResults from '@/components/search/noResults/NoResults.vue';
import TooliabaButton from '@/components/buttons/TooliabaButton.vue';
import StickyFooter from '@/components/global/StickyFooter.vue';
import { mapActions, mapState } from 'vuex';

export default {
    components: {
        HugeSpinner,
        TooliabaButton,
        StickyFooter,
        ToolList,
        NoResults,
        CardShell
    },
    computed: {
        ...mapState('listings', [
            'searchResults',
            'resultCount',
            'showMoreUrl',
            'searching'
        ])
    },
    methods: {
        ...mapActions('listings', ['getMoreResults']),
        filterResultsClick() {
            this.$router.push({
                path: '/mobile-filters',
                query: this.$route.query
            });
        }
    }
};
</script>
